import MicroModal from "micromodal";
import { useEffect } from "react";

const Modal = ({ id, children }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      MicroModal.init();
    }
  }, []);

  return (
    <div className="modal micromodal-slide" id={id} aria-hidden="true">
      <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
        <div className="modal__container" role="dialog" aria-modal="true">
          <div className="modal__content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
